import React from 'react'
import { Card, CardActionArea, CardMedia, CardContent, Typography, Box, Grid, CardHeader, Avatar, IconButton, Button } from '@mui/material'
import { grey, red } from '@mui/material/colors'
import PhoneEnabledIcon from '@mui/icons-material/PhoneEnabled';
import MarkunreadIcon from '@mui/icons-material/Markunread';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
function Chu1Component({ data, changeChu }) {
  return (
    <Card key={data.id} sx={{ cursor: 'pointer', margin: '5px', borderRadius: '20px', maxWidth: { md: 460, sm: 400, xs: 400 } }}  >
      <CardHeader
        avatar={
          <Avatar src={data.logo_chu} />
        }
        title={data.nom_chu}
        subheader={`${data.adresse_chu}`}
        sx={{
          '& .MuiCardHeader-title': {
            color: '#d82967',
            fontWeight:'bold'
          },
        }}
      />
      <Grid container sx={{ marginTop: '-30px' }}>
        <Grid item xs={4}>
          <CardMedia
            component="img"
            height="190"
            // width={50}
            image={data.photo_chu}
            style={{ objectFit: 'contain', borderRadius: '40px', padding: '2px', marginLeft: '5px' }}
            alt="green iguana"
          />
        </Grid>
        <Grid item xs={8}>
          <CardContent sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
            <Typography variant="body2" color="text.secondary">
              {data.description_chu}.
            </Typography>
            <Typography sx={{ margin: '0 0 2px 0' }} variant="body2" color="text.secondary">
              <i><b>Tél:</b> {data.contact_chu} {data.contact1_chu ? `/ ${data.contact1_chu}` : ''}</i>
            </Typography>
            <Typography sx={{ margin: '0 0 2px 0' }} variant="body2" color="text.secondary">
              <i><b>Email:</b> {data.email_chu}</i>
            </Typography>
            <Button
              component="label"
              role={undefined}
              variant="contained"
              tabIndex={-1}
              startIcon={<CalendarMonthIcon />}
              onClick={() => {
                changeChu(data.id, data.nom_chu, data.code_chu)
              }}
              size='small'
              sx={{ backgroundColor: '#d82967', ':hover': { backgroundColor: 'rgb(100, 1, 37)' } }}
            >
              {/* Prendre rendez-vous */}
              Famandrihan-toerana
            </Button>
          </CardContent>
        </Grid>
        {/* <Grid item xs={8} sx={{ p: 1 }}>
          
        </Grid> */}
      </Grid>
    </Card>
  )
}

export default Chu1Component